import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/applicationReminder/HowToCancel.png'
import _imports_1 from '@/assets/svg/credit_score_rules.svg'


const _withScopeId = n => (_pushScopeId("data-v-3f562c84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "header-text" }, "キャンセル方法")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "キャンセル方法",
  class: "image"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "header-text" }, "信用スコアの減点ルール"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", null, "事業所に連絡したタイミングで減点")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "信用スコアの減点ルール",
    class: "image"
  }),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", { class: "subtraction-rules-text" }, "\n        信用スコアが0ptになると応募済のお仕事も全てキャンセルとなり、一時的にお仕事へ応募不可になります\n      ")
], -1))
const _hoisted_6 = { class: "d-flex flex-column" }

import { ref } from "vue";

import AppButtonOutline from "@/components/atoms/button/AppButtonOutline.vue";
import AppButton from "@/components/atoms/button/AppButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HowToCancel',
  emits: ["back", "cancel"],
  setup(__props, { emit }) {



const onCancel = () => {
  emit("cancel");
};

const onBack = () => {
  emit("back");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createTextVNode(),
    _hoisted_3,
    _createTextVNode(),
    _hoisted_4,
    _createTextVNode(),
    _hoisted_5,
    _createTextVNode(),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(AppButton, {
        onClick: onCancel,
        class: "mb-2"
      }, {
        default: _withCtx(() => [
          _createTextVNode("お仕事のキャンセルに進む")
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _createVNode(AppButtonOutline, {
        onClick: onBack,
        variant: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("戻る")
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}
}

})